module.exports = __webpack_public_path__ + "static/media/Eyes_3.b8679ace.jpg";